import React, { useEffect, useRef, useState } from 'react';
import AppLayout from '../components/AppLayout';
import { auth } from '../services/firebase-init';

// ── Website (thewindowplacellc.com) inside the Hub ──────────────────────────
// The website's dashboard (leads, requests, design studio) lives on its own team-only
// address (twp-team.web.app), completely apart from the public website, and is shown here.
// One login: when it asks, we hand it this person's Hub sign-in (a short-lived Firebase
// ID token), only to the team address. Its server checks their Hub role (managers only)
// on every request — see website-functions/crm/auth.js.
const WEBSITE = (import.meta.env.VITE_TEAM_URL || 'https://twp-team.web.app').replace(/\/$/, '');
const TITLES = { overview: 'Website Dashboard', design: 'Design Studio' };   // leads and requests now live on the dashboard

export default function WebsitePage({ view = 'overview' }) {
  const frame = useRef(null);
  const [src] = useState(() => `${WEBSITE}/admin/#${view}`);   // load once; later menu clicks switch the view in place

  useEffect(() => {
    async function onMessage(e) {
      if (e.origin !== WEBSITE || e.source !== frame.current?.contentWindow) return;
      if (e.data?.type === 'twp-need-session') {
        const idToken = await auth.currentUser?.getIdToken().catch(() => '');
        if (idToken) frame.current.contentWindow.postMessage({ type: 'twp-hub-token', idToken }, WEBSITE);
      }
    }
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);

  // Menu click on another Website item: switch the page without reloading it
  // (only once the website page has loaded; before that it opens on the right view by itself).
  const loaded = useRef(false);
  useEffect(() => {
    if (loaded.current) frame.current?.contentWindow?.postMessage({ type: 'twp-hub-go', view }, WEBSITE);
  }, [view]);

  return (
    <AppLayout
      fullBleed
      title={TITLES[view]}
      breadcrumb={`Website › ${TITLES[view]}`}
    >
      <iframe
        ref={frame}
        src={src}
        onLoad={() => { loaded.current = true; }}
        title={TITLES[view]}
        allow="fullscreen; clipboard-write"
        style={{ display: 'block', width: '100%', height: '100%', border: 0, background: '#f5f2ed' }}
      />
    </AppLayout>
  );
}
